import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const FeatureItem = ({ title, desc, icon }) => (
  <div className="flex gap-6 items-start">
    <div className="w-12 h-12 bg-white border-2 border-retro-brown rounded-lg flex items-center justify-center shrink-0 shadow-retro-sm">
      <SafeIcon name={icon} className="text-xl text-retro-blue" />
    </div>
    <div>
      <h4 className="font-display text-xl uppercase mb-1">{title}</h4>
      <p className="font-body text-sm font-bold text-gray-600">{desc}</p>
    </div>
  </div>
);

const Features = () => {
  return (
    <section className="py-24 border-b-4 border-retro-brown bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter mb-4">
            What This Actually <br/><span className="text-retro-blue">Builds For You</span>
          </h2>
          <p className="font-body text-xl font-bold text-gray-500 max-w-2xl mx-auto">
            Visibility. Trust. Credibility. Recognition. The things that make homeowners choose you without comparing prices.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          <FeatureItem icon="Eye" title="Local Visibility" desc="Your business sits in 10,000 West Valley homes—not buried in a digital feed. Visible, physical, repeatedly seen." />
          <FeatureItem icon="Award" title="Instant Credibility" desc="Being featured alongside other trusted local businesses positions you as one of the area's preferred names." />
          <FeatureItem icon="Shield" title="Trust Before Sale" desc="Homeowners trust what they recognize. The guide builds familiarity months before they need your service." />
          <FeatureItem icon="Lock" title="Category Exclusivity" desc="Only one business per category in the entire guide. Your direct competitors are locked out of the edition." />
          <FeatureItem icon="Maximize" title="Premium Format" desc="9' x 12' oversized format. Homeowners don't toss it—it gets saved, pinned, and referenced." />
          <FeatureItem icon="Smartphone" title="QR Tracking" desc="A custom-tracked QR code so you see exactly how many homeowners engaged with your placement." />
        </div>

        <div className="mt-20 bg-retro-teal border-4 border-retro-brown rounded-[2rem] p-10 shadow-retro flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="max-w-xl">
            <h3 className="font-display text-4xl text-retro-cream uppercase tracking-tighter mb-4">No website? We'll build the landing page too.</h3>
            <p className="font-body text-retro-cream font-bold text-lg opacity-90">
              We'll build a clean one-page site so your QR code has a polished, trustworthy place to land. Keep it, upgrade it, or walk away—no pressure.
            </p>
          </div>
          <div className="bg-retro-cream p-6 border-4 border-retro-brown rounded-2xl transform rotate-2">
            <p className="font-display text-xl text-retro-brown uppercase">Done-For-You</p>
            <p className="font-body font-black text-[10px] text-retro-teal uppercase tracking-widest">Every Single Step</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;